import React from 'react';
import clsx from 'clsx';
import { ReactComponent as ArrowRightIcon } from 'common-assets/assets/icons/arrow-right-filled.svg';
import { useLastWord } from '../utils/useLastWord';

import useStyles from './MultipleWordsTextWithArrow.style';

export interface MultipleWordsTextWithArrowProps {
  text?: string;
  classNameWrapper: string;
  classNameText: string;
  classNameIcon: string;
  testId?: string;
}

const MultipleWordsTextWithArrow: React.FC<MultipleWordsTextWithArrowProps> = ({
  text,
  classNameWrapper,
  classNameText,
  classNameIcon,
  testId = 'MultipleWordsTextWithArrow',
}) => {
  const c = useStyles({});
  const { before, last } = useLastWord(text);
  const hasMultipleWords = Boolean(before?.trim());

  if (hasMultipleWords) {
    return (
      <span className={classNameWrapper} data-testid={testId}>
        <span className={classNameText}>{before}</span>
        <span className={c.lastWithIcon}>
          <span className={classNameText}>{last}</span>
          <ArrowRightIcon className={clsx(c.icon, classNameIcon)} data-testid={`${testId}-icon`} />
        </span>
      </span>
    );
  }

  return (
    <span className={classNameWrapper} data-testid={testId}>
      <span className={classNameText}>{text}</span>
      <ArrowRightIcon className={clsx(c.icon, classNameIcon)} data-testid={`${testId}-icon`} />
    </span>
  );
};

export default MultipleWordsTextWithArrow;

